import React from 'react';
import { useForm, SubmitHandler, Controller } from 'react-hook-form';
import Input from '../../../../components/elements/form/input';
import Teaxtarea from '../../../../components/elements/form/textarea';
import SelectBox from '../../../../components/elements/form/selectBox';
import { DropdownOptionType, Option } from '../../../../_config/types';
import Datepicker from '../../../../components/elements/form/datepicker';
import  Button  from '../../../../components/elements/button';
import { AgGridReact } from 'ag-grid-react';


type FormValues = {
    assetName: string;
    drop: DropdownOptionType;
    assetType: string;
    purchaseDate: Date;
};

const yourConstant = 'someValue';

const CreateStockpicking: React.FC = () => {
    const {control, register, handleSubmit, formState: { errors } } = useForm<FormValues>();
        
        const onSubmit: SubmitHandler<FormValues> = data => {
            console.log(data);
        };
        
        const columnDefs = [
            { headerName: 'Part Code', field: 'part-code', headerClass: 'bg-[#f0f0f0]'},
            { headerName: 'Part Name', field: 'part-name', headerClass: 'bg-[#f0f0f0]' },
            { headerName: 'Available Qty', field: 'available-qty', headerClass: 'bg-[#f0f0f0]' },
            { headerName: 'Pick Qty', field: 'pick-qty', headerClass: 'bg-[#f0f0f0]' },
            { headerName: 'Part Cost', field: 'cost', headerClass: 'bg-[#f0f0f0]' },
          ];
        
          // Define row data
          const rowData: any[] = [
            { 'part-code': 'RC 001', 'part-name': '5/30/24', 'available-qty': '05', 'pick-qty': '03', 'cost':'Adjustment Notes'},
            { 'part-code': 'RC 001', 'part-name': '5/30/24', 'available-qty': '05', 'pick-qty': '03', 'cost':'Adjustment Notes'},
            { 'part-code': 'RC 001', 'part-name': '5/30/24', 'available-qty': '05', 'pick-qty': '03', 'cost':'Adjustment Notes'},
            { 'part-code': 'RC 001', 'part-name': '5/30/24', 'available-qty': '05', 'pick-qty': '03', 'cost':'Adjustment Notes'},
            { 'part-code': 'RC 001', 'part-name': '5/30/24', 'available-qty': '05', 'pick-qty': '03', 'cost':'Adjustment Notes'},
            { 'part-code': 'RC 001', 'part-name': '5/30/24', 'available-qty': '05', 'pick-qty': '03', 'cost':'Adjustment Notes'},
            { 'part-code': 'RC 001', 'part-name': '5/30/24', 'available-qty': '05', 'pick-qty': '03', 'cost':'Adjustment Notes'},
            { 'part-code': 'RC 001', 'part-name': '5/30/24', 'available-qty': '05', 'pick-qty': '03', 'cost':'Adjustment Notes'},
            
          ];

    return (
         <form onSubmit={handleSubmit(onSubmit)}>
            <div className='pt-4'>
                <div className="grid grid-cols-2 gap-4">
                    <div className='bg-green-50 py-2 px-3'>
                        <h6 className='text-[0.813rem] font-semibold'>Pick No</h6>
                        <p className='text-[0.813rem] font-normal mt-2'>P 001</p>
                    </div>
                    <div className='bg-green-50 py-2 px-3'>
                        <h6 className='text-[0.813rem] font-semibold'>Date and Time</h6>
                        <p className='text-[0.813rem] font-normal mt-2'>10/18/2024 - 05.00PM</p>
                    </div>
                </div>
                <div className='grid grid-cols-2 gap-2'>
                        <Controller
                                    name='drop'
                                    control={control}
                                    render={({ field :{value,onChange} }) => (
                                        <SelectBox 
                                        label='Picked By'
                                        value={value}
                                        onChange={onChange}
                                        required
                                        placeholder='Picked By'
                                        options={[]}
                                        className='mb-0'
                                        />
                                    )}
                                />
                            <Controller
                                name='assetName'
                                control={control}
                                render={({ field :{value,onChange} }) => (
                                    <Input 
                                    label='Ref Work Order'
                                    type='text'
                                    value={value}
                                    onChange={onChange}
                                    placeholder='Ref Work Order'

                                    />
                                )}
                            />
                         
                </div>
                       <Controller
                            name='drop'
                            control={control}
                            render={({ field :{value,onChange} }) => (
                                <SelectBox 
                                label='Select Facility'
                                value={value}
                                onChange={onChange}
                                required
                                placeholder='AF Farm 1'
                                options={[]}
                                className='mb-0'
                                />
                            )}
                        />
                        <Controller
                            name='drop'
                            control={control}
                            render={({ field :{value,onChange} }) => (
                                <SelectBox 
                                label='Select Sub Facility'
                                value={value}
                                onChange={onChange}
                                required
                                placeholder='Western Regional'
                                options={[]}
                                className='mb-0'
                                />
                            )}
                        />
              
              <h4 className='font-semibold text-[0.938rem] py-4 uppercase'>Ref Cycle Count</h4>
                <div className="ag-theme-alpine h-1/2">
                                    <AgGridReact
                                        columnDefs={columnDefs} // Pass columnDefs
                                        rowData={rowData} // Pass rowData
                                        pagination={false}
                                        domLayout="autoHeight"
                                    />
                                </div>
                
                <Controller
                    name='assetName'
                    control={control}
                    render={({ field :{value,onChange} }) => (
                        <Teaxtarea 
                        label='Notes'
                        value={value}
                        onChange={onChange}
                        required
                        placeholder='Write Your Notes'
                         />
                    )}
                />
               
                <hr className='border-gray-900 my-6' />
            </div>
          <div className='flex justify-end gap-2'>
                <Button working={false}>Save</Button>
                <Button theme='secondary' working={false}>Cancel</Button>
            </div>  

            <input id="assetName" {...register('assetName', { required: true })} />
                {errors.assetName && <span>This field is required</span>}

            <div>
                <label htmlFor="assetType">Asset Type</label>
                <input id="assetType" {...register('assetType', { required: true })} />
                {errors.assetType && <span>This field is required</span>}
            </div>

            <div>
                <label htmlFor="purchaseDate">Purchase Date</label>
                <input id="purchaseDate" type="date" {...register('purchaseDate', { required: true })} />
                {errors.purchaseDate && <span>This field is required</span>}
            </div>

            <button type="submit">Create Asset</button>
        </form>
    );
};

export default CreateStockpicking;
